module.exports = __webpack_public_path__ + "img/新能源产业专利动态图片.0705bbe0.png";